import { useState, useEffect } from 'react';

// Custom hook pro expandaci kategorie - zobrazení produktů v kategorii
export const useExpanded = (phaseStep, defaultExpanded) => {
    const [expanded, setExpanded] = useState(defaultExpanded);

    const toggleExpanded = () => {
        setExpanded((prevValue) => !prevValue);
    };

    useEffect(() => {
        setExpanded(false);
    }, [phaseStep]);

    useEffect(() => {
        setExpanded(defaultExpanded);
    }, [defaultExpanded]);

    return { expanded, toggleExpanded };
};
